
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M0 0h20v20H0z"}}),_c('path',{attrs:{"d":"M8.335 15.858a.833.833 0 01-.642-1.367l3.733-4.467-3.6-4.475a.833.833 0 01.125-1.175.833.833 0 011.217.125l4.025 5a.833.833 0 010 1.059l-4.167 5a.833.833 0 01-.691.3z","fill":"#001C45"}})])])
          )
        }
      }
    